module.exports = __webpack_public_path__ + "static/media/TH.d60d73ec.png";